import instance from "../apis/axiosConfig";

// Create
export const createWork = (data) => {
  return instance.post("work/create", data);
};

// Get All
export const getAllWorks = (page, limit) => {
  return instance.get(`work/allwork?page=${page}&limit=${limit}`);
};

// Update Size
export const updateWorkSize = (id, data) => {
  return instance.post(`work/update/${id}`, data);
};

// Publish Status 
export const updatePublishStatus = (id, data) => {
  return instance.post(`work/status/${id}`, data);
};

// Delete
export const deleteWork = (id) => {
  return instance.delete(`work/delete/${id}`);
};

export const getAllImageSizes = () => {
  return instance.get("imageSize/all");
};

// PRIORITY UPDATE
export const updatePriority = (data) => {
  return instance.post("work/priority", data);
};

// UPDATE TOPIC + TITLE
export const updateWorkDetails = (id, data) => {
  return instance.post(`work/update-details/${id}`, data);
};

// UPDATE WORK IMAGE
export const updateWorkImage = (id, data) => {
  return instance.post(`work/update-work-image/${id}`, data);
};

// UPDATE PORTFOLIO IMAGE
export const updatePortfolioImage = (id, data) => {
  return instance.post(`work/update-portfolio-image/${id}`, data);
};